import React from 'react';
import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import navIcon1 from '../../assets/images/icon-documento.png';
import navIcon2 from '../../assets/images/icon-livro-aberto.png';
import navIcon3 from '../../assets/images/icon-people.png';
import navIcon4 from '../../assets/images/icon-pesquisar.png';
import './DadosSite.css'

const DadosSite = () => {
  const data = [
    { id: 1, icon: navIcon1, count: '58', label: 'Documentos' },
    { id: 2, icon: navIcon2, count: '11528', label: 'Páginas indexadas' },
    { id: 3, icon: navIcon3, count: '104342', label: 'Visitas no Site' },
    { id: 4, icon: navIcon4, count: '13719', label: 'Consultas de documentos' },
  ];

  return (
    <section className="counter-wrapper section-sm">
      <div className="container">
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} textAlign="center">
            <Typography
                           variant="h2"
                           align="center"
                           gutterBottom
                           style={{
                             fontFamily: "'Lato', serif",
                             color: "#800020",
                             borderBottom: "4px solid #d4af37",
                             paddingBottom: "10px",
                             textTransform: "uppercase",
                             animation: "glow 2s infinite alternate",
                             textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                             marginTop: "7%"  // Aqui é onde você define o espaço superior
                           }}
                         >
              Uma história da Península
            </Typography>
            <Grid item xs={12}>
  <Typography 
    variant="body1" 
    color="textSecondary" 
    sx={{ fontFamily: 'Georgia, serif' }} // Define uma fonte serifada para combinar com o tema histórico
  >
    O grupo "Ensino da Fé Cristã na Península Ibérica" dedica-se a investigar o processo de incorporação e adaptação das crenças cristãs nos contextos ibéricos ao longo da Idade Média e do início da Era Moderna. Seu objetivo é compreender como as doutrinas e práticas cristãs foram assimiladas, reinterpretadas e transformadas pelas diversas sociedades ibéricas, considerando as particularidades culturais, políticas e religiosas de cada período histórico. A pesquisa busca oferecer novos insights sobre as dinâmicas de interação entre a tradição cristã e os contextos locais, revelando os fatores que moldaram a vivência e a transmissão da fé ao longo do tempo.
  </Typography>
</Grid>
 </Grid>

          {data.map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.id} textAlign="center">
              <Card variant="outlined" sx={{ boxShadow: 3 }}>
                <CardContent>
                  <Box mb={2}>
                    <img src={item.icon} alt={item.label} style={{ maxWidth: '50px', marginBottom: '10px' }} />
                  </Box>
                  <Typography variant="h4" component="span" color="primary" display="block">
                    {item.count}
                  </Typography>
                  <Typography variant="h6" component="h3" color="textSecondary" mt={1}>
                    {item.label}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export default DadosSite;
